import { SheetDescription } from '@svs/ui/react/sheet';
import type { PropsWithChildren, ReactNode } from 'react';

type TipsenSheetDescriptionProps = PropsWithChildren<{ className?: string }>;

/**
 * TipsenSheet description wrapper.
 *
 * @param root0 root
 * @param root0.children children of the component
 * @param root0.className optional class name to apply to the description
 * @returns TipsenSheet description wrapper.
 */
export default function TipsenSheetDescription({ className, children }: TipsenSheetDescriptionProps): ReactNode {
  return <SheetDescription className={className}>{children}</SheetDescription>;
}
